import { Col, Row } from "react-bootstrap";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa1, fa2, fa3, fa4, fa5, fa6, fa7, faCircle } from "@fortawesome/free-solid-svg-icons";

function MarginCalculatorHeader({ account, name, isMargin = false }) {
  return (
    <div className="mb-3">
      <Row className="d-flex align-items-center">
        <Col md={12} lg={12} xl={4}>
          <div
            className={clsx("custom-table-title-container justify-content-xl-start justify-content-center")}
          >
            <p> {name} </p>
            <p> ({account}) </p>
          </div>
        </Col>
        {isMargin ? (
          <Col md={12} lg={12} xl={8}>
            <div className="d-flex align-items-center justify-content-xl-end mt-3 my-xl-0 margin-simulator-hotkey">
              <div className="hotkey-inner-content align-items-center">
                <span className="fa-stack">
                  <FontAwesomeIcon icon={faCircle} className="fa-stack-2x fa-inverse custom-inverse-color" />
                  <FontAwesomeIcon
                    icon={fa1}
                    className="fa-stack-1x fa-inverse"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <p>General Settings</p>
              </div>
              <div className="hotkey-inner-content align-items-center">
                <span className="fa-stack">
                  <FontAwesomeIcon icon={faCircle} className="fa-stack-2x fa-inverse custom-inverse-color" />
                  <FontAwesomeIcon
                    icon={fa2}
                    className="fa-stack-1x fa-inverse"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <p>Buy In</p>
              </div>
              <div className="hotkey-inner-content align-items-center">
                <span className="fa-stack">
                  <FontAwesomeIcon icon={faCircle} className="fa-stack-2x fa-inverse custom-inverse-color" />
                  <FontAwesomeIcon
                    icon={fa3}
                    className="fa-stack-1x fa-inverse"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <p>Sell Out</p>
              </div>
              <div className="hotkey-inner-content align-items-center">
                <span className="fa-stack">
                  <FontAwesomeIcon icon={faCircle} className="fa-stack-2x fa-inverse custom-inverse-color" />
                  <FontAwesomeIcon
                    icon={fa4}
                    className="fa-stack-1x fa-inverse"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <p>Transfer In</p>
              </div>
              <div className="hotkey-inner-content align-items-center">
                <span className="fa-stack">
                  <FontAwesomeIcon icon={faCircle} className="fa-stack-2x fa-inverse custom-inverse-color" />
                  <FontAwesomeIcon
                    icon={fa5}
                    className="fa-stack-1x fa-inverse"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <p>Transfer Out</p>
              </div>
              <div className="hotkey-inner-content align-items-center">
                <span className="fa-stack">
                  <FontAwesomeIcon icon={faCircle} className="fa-stack-2x fa-inverse custom-inverse-color" />
                  <FontAwesomeIcon
                    icon={fa6}
                    className="fa-stack-1x fa-inverse"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <p>Cash In</p>
              </div>
              <div className="hotkey-inner-content align-items-center">
                <span className="fa-stack">
                  <FontAwesomeIcon icon={faCircle} className="fa-stack-2x fa-inverse custom-inverse-color" />
                  <FontAwesomeIcon
                    icon={fa7}
                    className="fa-stack-1x fa-inverse"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <p>Cash Out</p>
              </div>
            </div>
          </Col>
        ) : (
          false
        )}
      </Row>
    </div>
  );
}

export default MarginCalculatorHeader;
